module.exports = __webpack_public_path__ + "img/ledger.5dfe2fc4.svg";